import { render, staticRenderFns } from "./NewOrderModal.vue?vue&type=template&id=1825c94e&"
import script from "./NewOrderModal.vue?vue&type=script&lang=ts&"
export * from "./NewOrderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VForm,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1825c94e')) {
      api.createRecord('1825c94e', component.options)
    } else {
      api.reload('1825c94e', component.options)
    }
    module.hot.accept("./NewOrderModal.vue?vue&type=template&id=1825c94e&", function () {
      api.rerender('1825c94e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/machinetranslations/NewOrderModal.vue"
export default component.exports